<template>
  <div class="indexBox">
    <div class="bigImg">
      <div class="bannerRight">
        <img class="gifLine" src="@static/index/0.gif" alt="">
        <img class="positionImg img1" src="@static/index/position1.png" alt="">
        <img class="positionImg img2" src="@static/index/position2.png" alt="">
        <img class="positionImg img3" src="@static/index/position3.png" alt="">
      </div>
      <div class="bannerLeft">
        <p class="txtP">
          The strong motivation from the internal creative and media-buy <br> team guarantees you high quality CPA performance.
        </p>
        <p class="btnP">
          <span class="transformBtn join" @click="goSignUp">JOIN NOW</span>
          <span class="transformBtn more" @click="goVital('#vital')">More info</span>
        </p>
      </div>
    </div>
    <!-- About Vertads -->
    <div class="about">
      <h3>About VertAds</h3>
      <div class="center">
        <div>
          <img src="@static/index/1.gif" alt="">
          <p class="number"><span v-change="2000">150</span> +</p>
          <span class="tit">COVERAGE</span>
          <p>
            With the various media sources covered, we can guarantee worldwide coverage for your budget.
          </p>
        </div>
        <div>
          <img src="@static/index/2.gif" alt="">
          <p class="number"><span v-change="2000">20</span> +</p>
          <span class="tit">MEDIA SOURCES</span>
          <p>
            With certificated by GoogleAds, Meta and others, we have built a range of sourece pool to make sure every offer could match the best traffic.
          </p>
        </div>
        <div>
          <img src="@static/index/3.gif" alt="">
          <p class="number"><span v-change="2000">500</span> +</p>
          <span class="tit">ACTIVE PUBLISHERS</span>
          <p>
            Our channels are a powerful boost to business growth and continue to empower advertisers with professional performance
          </p>
        </div>
        <div>
          <img src="@static/index/4.gif" alt="">
          <p class="number"><span v-change="2000">30</span> +</p>
          <span class="tit">MEDIA BUYER</span>
          <p>
            The internal delivery team ensures the stability and independence of the business
          </p>
        </div>
      </div>
    </div>
    <!-- why Vertads -->
    <div class="why">
      <h3>Why VertAds?</h3>
      <div class="center">
        <div>
          <img src="@static/index/why1.png" alt="">
          <p>
            <span>In-house Developed Offers</span>
            <span></span>
            <span>The internal delivery team <br> ensures the stability and <br> independence of the business</span>
          </p>
        </div>
        <div>
          <p>
            <span>Dedicated Account Manager</span>
            <span></span>
            <span>Need help getting started? Add <br> your Account Manager on Skype <br> andget direct 24/7 personal <br> support, useful tips and insigh</span>
          </p>
          <img src="@static/index/why2.png" alt="">
        </div>
        <div>
          <img src="@static/index/why3.png" alt="">
          <p>
            <span>Various Integration Way</span>
            <span></span>
            <span>We do support both S2S and API <br> integration way to boost your <br> business</span>
          </p>
        </div>
        <div>
          <p>
            <span>Powerful Creative Production Ability</span>
            <span></span>
            <span>In-house experienced creative design <br> ensures the independence <br> andcreativity of the advertisement</span>
          </p>
          <img src="@static/index/why4.png" alt="">
        </div>
      </div>
    </div>
    <!-- EVENT & RESOURCE -->
    <div class="event">
      <h3>EVENT & RESOURCE</h3>
      <div class="swiperVert">
        <swiper :options="swiperOption"> 
          <div class="swiper-slide">
            <img src="@static/index/s1.png" alt="">
            <p>AWE 2023-Barcelona, Spain</p>
          </div>
          <div class="swiper-slide">
            <img src="@static/index/s2.png" alt="">
            <p>AWA 2023-Bangkok, Thailand</p>
          </div>
          <div class="swiper-slide">
            <img src="@static/index/s3.png" alt="">
            <p>Telemedia 2019-Marbella, Spain</p>
          </div>
          <div class="swiper-slide">
            <img src="@static/index/s4.png" alt="">
            <p>TES 2019-Prague, Czech Republic</p>
          </div>
          <!-- 分页器 -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <!-- Our Partners -->
    <div class="partners" style="margin: 60px 0 0px;">
      <h3>Our Partners</h3>
      <div>
        <img src="@static/index/p1.png" alt="">
        <img src="@static/index/p2.png" alt="">
        <img src="@static/index/p3.png" alt="">
      </div>
      <div>
        <img src="@static/index/p4.png" alt="">
        <img src="@static/index/p5.png" alt="">
        <img src="@static/index/p6.png" alt="">
      </div>
    </div>
    <!-- Connected Media -->
    <div class="partners second">
      <h3>Connected Media</h3>
      <div>
        <img src="@static/index/m1.png" alt="">
        <img src="@static/index/m2.png" alt="">
        <img src="@static/index/m3.png" alt="">
      </div>
      <div>
        <img src="@static/index/m4.png" alt="">
        <img src="@static/index/m5.png" alt="">
        <img src="@static/index/m6.png" alt="">
      </div>
    </div>
    <div class="positionBox" id="vital"></div>
  </div>
</template>
<script>
  export default {
    name: 'indexWap',
    data() {
      return {
        // swiper 参数
        swiperOption: {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          grabCursor:true,
          loop: true,
          preventClicks : true,
           //自动播放
          autoplay: {
            delay: 3000, //延迟播放下一张图片
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            // dynamicBullets: true,
            // type:'custom',
            // renderCustom: function (swiper, current, total) {
            //   if(current === 1){
            //     return '<span class="swiperOne"><li><span></span></li><span class="swiperOneSpan"></span><span></span></span>';
            //   }else if(current === 2){
            //     return `<span class="swiperTwo"><span></span><li><span></span></li><span></span></span>`;
            //   }else{
            //     return `<span class="swiperThree"><span></span><span class="swiperThreeSpan"></span><li><span></span></li></span>`;
            //   }
            // }
          },
        },
        screenWidth:'',
      }
    },
    created(){
      // // 自动切换serveBox
      // setInterval(this.updateDiv, 4000);
      // 传参控制显示顶部和底部
      this.$emit('controlShow', false);
    },
    mounted() {
      //获取屏幕尺寸
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        //屏幕尺寸变化
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    methods: {
      goSignUp(){
        this.$store.commit('setMenuKey','4');
        this.$router.push({
          name: "signup"
        });
      },
      goVital(e){
        console.log(e);
        setTimeout(() => {
          document.querySelector(e).scrollIntoView({
            behavior: "auto",
          })
        }, 100);
      }
    },
    computed: {
      //计算高度
      computeHeight() {
        let screenHeight = document.body.scrollTop;
        console.log(screenHeight);
        if (screenHeight > 415) {
          return '550px';
        } else {
          return '250px';
        }
      },
      advertiser(){
        return this.$store.state.advertiser;
      }
    },
    watch:{
      advertiser:{
        handler(val){
          console.log(val);
          if(val){
            this.goVital(val);
          }
        },
        immediate: true
      },
      screenWidth: function (n) {
        if (n > 500) {
          this.$router.push({
            name: "Index"
          });
        }
      },
    }
  }
</script>

<style lang="less" scoped>
.indexBox{
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 20px;
  position: relative;
  .positionBox{
    width: 100px;
    height: 10px;
    background: #CD2128;
    position: absolute;
    top: 13%;
    opacity: 0;
  }
  .bigImg{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    .bannerLeft{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      margin-top: 60px;
      .txtP{
        font-size: 12px;
        font-weight: 500;
        scale: 0.95;
      }
      .btnP{
        width: 80%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 30px 0;
        span{
          width: 70px;
          height: 28px;
          border-radius: 4px;
          font-size: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
        }
        .join{
          background: linear-gradient(to left, #E11F27 0%, #AE2025 100%,);
        }
        .more{
          border: 1px solid #BC242A;
          color: #CD2128;
        }
      }
    }
    .bannerRight{
      width: 65%;
      height: 160px;
      margin-top: 50px;
      background: url('~@static/index/bannerRight.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;
      position: relative;
      box-sizing: border-box;
      .gifLine{
        width: 95%;
        height: auto;
        margin-bottom: 40px;
      }
      .positionImg{
        width: 135px;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
      }
      .img1{
        top: 80px;
        left: 120px;
        // animation: slide2 2s ease;
      }
      .img2{
        top: 50px;
        left: 135px;
        // animation: slide1 2s ease;
        animation-delay: 1s;
      }
      .img3{
        top: 35px;
        left: 155px;
        // animation: slide 2s ease;
        animation-delay: 2s;
      }
      @keyframes slide{
        from {
          transform: translateX(250px);
          opacity: 0;
        }
        to {
          transform: translateX(0px);
          opacity: 1;
        }
      }
      @keyframes slide1{
        from {
          transform: translateX(250px);
          opacity: 0;
        }
        to {
          transform: translateX(0px);
          opacity: 1;
        }
      }
      @keyframes slide2{
        from {
          transform: translateX(250px);
          opacity: 0;
        }
        to {
          transform: translateX(0px);
          opacity: 1;
        }
      }
    }
  }
  .about{
    width: 100%;
    margin: 20px auto;
    h3{
      text-align: center;
      font-size: 16px;
      margin: 25px 0 40px;
    }
    .center{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;
      div{
        width: 45%;
        min-height: 210px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        img{
          width: 30px;
          height: 30px;
        }
        p{
          text-align: center;
          font-size: 12px;
          scale: 0.9;
          margin: 0;
          margin-top: 5px;
        }
        .number{
          color: #D8373D;
          font-size: 14px;
          font-weight: 600;
          margin: 5px auto;
        }
        .tit{
          font-size: 12px;
          scale: 0.95;
          color: #010201;
          font-weight: 600;
        }
      }
    }
  }
  .why{
    width: 100%;
    margin: 0 auto;
    h3{
      text-align: center;
      font-size: 16px;
      margin: 25px 0;
    }
    .center{
      width: 80%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      div{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        img{
          width: 100px;
          height: auto;
        }
        p{
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          span{
            display: inline-block;
            font-size: 12px;
            color: #010101;
          }
          span:nth-child(2){
            width: 20px;
            height: 2px;
            background-color: #5C3D45;
            margin: 15px 0;
          }
          span:nth-child(1){
            font-size: 12px;
            color: #D42229;
            font-weight: 500;
          }
        }
      }
    }
  }
  .event{
    width: 100%;
    margin: 20px auto;
    h3{
      text-align: center;
      font-size: 16px;
      margin: 25px 0;
    }
    .swiperVert{
      width: 90%;
      margin: 0 auto;
      /deep/ .swiper-container{
        position: relative;
        .swiper-slide{
          img{
            width: 100%;
            height: 220px;
            object-fit: cover;
          }
          p{
            position: absolute;
            bottom: -5px;
            left: 0;
            width: 100%;
            height: 22px;
            background: rgba(0, 0, 0, 0.38);
            text-align: center;
            line-height: 22px;
            color: #fff;
            font-size: 12px;
          }
        }
        .swiper-pagination{
          .swiper-pagination-bullet-active{
            background-color: #e1352a;
          }
        }
      }
    }
  }
  .partners{
    width: 100%;
    margin: 0 auto 80px;
    h3{
      text-align: center;
      font-size: 16px;
      margin: 25px 0 0;
    }
    div{
      width: 90%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      img{
        display: inline-block;
        width: 80px;
        height: auto;
      }
    }
  }
  .second{
    h3{
      margin-bottom: 20px;
    }
    div{
      img{
        width: 60px;
      }
    }
  }
}
  
  /deep/ #box{
    margin-top: 100px;
  }
  
  // 设置swiper分页器盒子的样式
  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
    width: auto;
    bottom: 10px;
    border-radius: 0% !important;
  }
  // 设置swiper分页器按钮的样式
  /deep/ .swiper-pagination-bullet{
    width: 5px;
    height: 5px;
    border-radius: 0;
    background-color: #fff;
    opacity: 1;
    margin: 0 3px !important;
  }
  /deep/ .swiperOne{
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      width: 4px;
      height: 4px;
      background-color: #999999;
      border-radius: 50%;
    }
    li{
      width: 20px;
      height: 20px;
      border: 2px solid #d52226;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      span{
        width: 4px;
        height: 4px;
        background-color: #d52226;
        border-radius: 50%;
      }
    }
    .swiperOneSpan{
      margin: 0 30px;
    }
  }
  /deep/ .swiperTwo{
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      width: 4px;
      height: 4px;
      background-color: #999999;
      border-radius: 50%;
    }
    li{
      width: 20px;
      height: 20px;
      border: 2px solid #d52226;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 30px;
      span{
        width: 4px;
        height: 4px;
        background-color: #d52226;
        border-radius: 50%;
      }
    }
  }
  /deep/ .swiperThree{
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      width: 4px;
      height: 4px;
      background-color: #999999;
      border-radius: 50%;
    }
    li{
      width: 20px;
      height: 20px;
      border: 2px solid #d52226;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      span{
        width: 4px;
        height: 4px;
        background-color: #d52226;
        border-radius: 50%;
      }
    }
    .swiperThreeSpan{
      margin: 0 30px;
    }
  }
</style>